<template>
  <div>
    <!-- <section class="catg-area">
      <div class="container">
        <CategoryList />
      </div>
    </section> -->
    <section class="client-listing-area">
      <div class="client-listing-head-fluid" style="padding-bottom: 5px;">
        <div class="container">
          <div class="client-listing-head">
            <SearchBar />
          </div>
          <!-- ends client-listing-head -->
        </div>
      </div>
      <!-- ends client-listing-head-fluid -->
      <div class="client-listing-detail-fluid">
        <div class="container px-0">
          <div class="client-listing-detail">
            <ApplicantList />
          </div>
          <!-- ends client-listing-detail -->
        </div>
      </div>
      <!-- ends client-listing-detail-fluid -->
    </section>
  </div>
</template>

<script>
import ApplicantList from '@/components/dashboard/applicants/ApplicantList.vue';
import SearchBar from '@/components/dashboard/applicants/SearchBar.vue';
// import CategoryList from '@/components/dashboard/category/CategoryList.vue';
// import { mapGetters } from 'vuex';
import { mapGetters, mapActions } from 'vuex';
import { mapMutations } from 'vuex';

export default {
  name: 'Applicants',
  components: { SearchBar, ApplicantList },
  
  mounted() {
    this.changeBodyBackground();
    
    // If user is already loaded, check immediately
    if (this.user && !this.isReviewer) {
      this.$router.push('/pending-applicants');
    }
  },
  
  watch: {
    // Watch for when user gets loaded and then check permissions
    user(newUser) {
      if (newUser && !this.isReviewer) {
        this.$router.push('/pending-applicants');
      }
    }
  },
  
  methods: {
    ...mapMutations({
      setStatusModel: 'setStatusModel',
      setProfileModalState: 'setProfileModalState',
    })
  },
  
  computed: {
    ...mapGetters({
      isReviewer: 'isCreateReviewUser',
      user: 'getCurrentUser'
    })
  },
  
  beforeRouteLeave(to, from, next) {
    this.setProfileModalState(false);
    this.setStatusModel([]);
    next();
  },
};
</script>